// src/context/AppDataContext.js
import React, { createContext, useContext, useState, useEffect } from "react"
import Cookies from "js-cookie"

const VariableDataContext = createContext()

export const VariableDataProvider = ({ children }) => {
  const [client, setClient] = useState(null)
  const [clients, setClients] = useState(null)
  const [carriers, setCarriers] = useState(null)
  const [organizations, setOrganizations] = useState(null)
  const [profileTypes, setProfileTypes] = useState(null)
  const [selectedClientInfo, setSelectedClientInfo] = useState(null)

  const setClientFromCookie = (_clients) => {
    const savedClientId = Cookies.get("client_id")
    // console.log("clients", _clients)
    // console.log("savedClientId", savedClientId)
    if (savedClientId) {
      setClient(savedClientId)
      if (_clients && _clients.length > 0) {
        const _selectedClient = _clients ? _clients.find((_c) => _c.id?.toString() === savedClientId.toString()) : null
        // console.log("_selectedClient", _selectedClient)
        setSelectedClientInfo(_selectedClient)
      }
    }
  }

  const updateClient = (clientId) => {
    if (clientId) {
      if (clients && clients.length > 0) {
        const _selectedClient = clients ? clients.find((_c) => _c.id?.toString() === clientId.toString()) : null
        setSelectedClientInfo(_selectedClient)
      }
      setClient(clientId)
      Cookies.set("client_id", clientId, { expires: 7 })
    } else {
      setClient(null)
      setSelectedClientInfo(null)
      Cookies.remove("client_id")
    }
  }

  const updateCurrentClientLabel = (newLabel) => {
    if (client) {
      const allClient = clients
      let currentClient = allClient.find((_c) => _c.id?.toString() === client.toString())
      currentClient.label = newLabel
      setSelectedClientInfo({ ...selectedClientInfo, label: newLabel })
      setClients(allClient)
    }
  }

  return (
    <VariableDataContext.Provider
      value={{
        client,
        setClient: updateClient,
        clients,
        setClients,
        carriers,
        setCarriers,
        organizations,
        setOrganizations,
        setProfileTypes,
        profileTypes,
        selectedClientInfo,
        setSelectedClientInfo,
        updateCurrentClientLabel,
        setClientFromCookie,
      }}
    >
      {children}
    </VariableDataContext.Provider>
  )
}

export const useVariableData = () => useContext(VariableDataContext)
